module.exports = __webpack_public_path__ + "img/zi-xdf.2feac3c5.png";